import { get } from "lodash";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { buildAtId } from "../../utils/utils.js";
import { Header } from "semantic-ui-react";

import Entitiy404 from "../../components/entity404/Entitiy404.jsx";
import UnauthorisedFeature from "../../components/auth/UnauthorisedFeature.jsx";
import SimplePreloader from "../../components/preloaders/SimplePreloader.jsx";
import ActionDropdownMenu from "../../components/actionDropdownMenu/ActionDropdownMenu.jsx";
import ResourceMarker from "../../components/marking/ResourceMarker.jsx";
import MarkingMessage from "../../components/marking/MarkingMessage.jsx";
import ImageDetailsPanel from "../../components/images/imageDetailsPanel/ImageDetailsPanel.jsx";
import UsagePanel from "../../components/usage/UsagePanel.jsx";
import SunsetMessage from "../../components/images/SunsetMessage.jsx";
import withConfirmationModal from "../../components/modals/withConfirmationModal.js";

import { OPERATIONS } from "../../constants/operations.js";
import { ENTITIES, IMAGES } from "../../state/actions/actionConstants.js";
import {
  ACTION_URI_CHUNKS,
  AT_TYPES,
  RESOURCE_KEYS,
  RESOURCE_URI_CHUNKS
} from "../../constants/entity.js";

import { getEntityAction } from "../../state/actions/entityActions.js";
import { operationAction } from "../../state/reducers/operations/operationActions.js";
import { corePartRefreshAction } from "../../state/reducers/core/coreActions.js";

import imageSelector from "../../state/reducers/images/imageSelector.js";
import { selectOperationAvailability } from "../../state/reducers/endpoints/endpointSelector.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class Image extends Component {
  static propTypes = {
    copyKey: PropTypes.string.isRequired,

    data: PropTypes.object,
    markingData: PropTypes.object,
    isFetching: PropTypes.bool.isRequired,
    lastCreated: PropTypes.string,
    listImageAvailability: PropTypes.object.isRequired,
    copy: PropTypes.func.isRequired,

    openModal: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,

    getEntityAction: PropTypes.func.isRequired,
    operationAction: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "image"
  };

  constructor(props) {
    super(props);

    this.state = {
      dataAtId: buildAtId(props.match.params, RESOURCE_URI_CHUNKS.IMAGES),
      showModal: false,
      modalCopy: {},
      modalAction: null
    };
  }

  componentDidMount = () => {
    this.getData();
  };

  componentDidUpdate = prevProps => {
    if (this.props.location !== prevProps.location) {
      this.getData();
    }
  };

  getData = () => {
    this.props.getEntityAction(this.state.dataAtId, undefined, [
      RESOURCE_KEYS.SOURCE,
      RESOURCE_KEYS.CHARGE,
      RESOURCE_KEYS.USAGE
    ]);
  };

  // -- HANDLERS -- //

  handleDelete = () => {
    const { data, openModal, copyKey } = this.props;
    openModal(this.doDelete, `${copyKey}.modals.delete_modal`, undefined, data);
  };

  doDelete = () => {
    const { data, operationAction } = this.props;
    operationAction(data, OPERATIONS.DELETE, undefined, {
      success: corePartRefreshAction(IMAGES, AT_TYPES.IMAGE)
    });
  };

  doEdit = values => {
    const { data, operationAction } = this.props;
    operationAction(data, OPERATIONS.UPDATE, values, {
      success: corePartRefreshAction(IMAGES, AT_TYPES.IMAGE)
    });
  };

  // -- RENDER -- //

  render() {
    const {
      data,
      markingData,
      isFetching,
      listImageAvailability,
      copyKey,
      copy
    } = this.props;

    // early return if resource isn't ready to render
    if (isFetching) {
      return <SimplePreloader />;
    }

    if (!data || !data["@id"]) {
      return (
        <Entitiy404
          id={buildAtId(this.props.match.params, RESOURCE_URI_CHUNKS.IMAGES)}
          type={copy(`resource_types.singular.${RESOURCE_URI_CHUNKS.IMAGES}`)}
        />
      );
    }

    // display unauthorised component if user diesn't have valid flags set
    if (!listImageAvailability.permitted) {
      return <UnauthorisedFeature title={copy(`${copyKey}.title`)} />;
    }

    const cloneImagePath = `/${RESOURCE_URI_CHUNKS.IMAGES}/${ACTION_URI_CHUNKS.CLONE}${data["@id"]}`;

    return (
      <Fragment>
        <ActionDropdownMenu
          data={data}
          onDelete={this.handleDelete}
          cloneImagePath={cloneImagePath}
          copy={copy(`basic_resource_actions`)}
        />
        <Header as="h3" className="action-dropdown-header">
          {get(data, "name", "Unknown")}
        </Header>
        <ResourceMarker marking={data.marking} className="project-marker" />

        {markingData && (
          <MarkingMessage
            type={MarkingMessage.IMAGE}
            message={markingData.message}
          />
        )}

        <SunsetMessage data={data} />

        <ImageDetailsPanel data={data} doEdit={this.doEdit} disabled={false} />

        <UsagePanel
          data={data}
          showTime={false}
          measurements={false}
          disabled={false}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, props) => ({
  data: imageSelector.selectImage()(state, props),
  markingData: imageSelector.selectMarkingMessageByEntity(state, props),
  isFetching: state.ephemeralEntities.isFetching || state.images.isFetching, // required to manage redirect on POST success
  lastCreated: state.ephemeralEntities.lastCreated,
  listImageAvailability: selectOperationAvailability(state)(
    AT_TYPES.IMAGE,
    OPERATIONS.LIST
  ),
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  getEntityAction: (...args) => dispatch(getEntityAction(...args)),
  getResource: (...args) => dispatch(getResource(...args)),
  operationAction: (entity, operationName, values, options) =>
    dispatch(operationAction(ENTITIES, entity, operationName, values, options))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withConfirmationModal(Image));
